import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from '../NavBar';

const MainLayout = ({ children }) => {
  const location = useLocation();
  const isAuthPage = ['/login', '/register'].includes(location.pathname);
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {!isAuthPage && <NavBar isCollapsed={isCollapsed} onToggleCollapse={() => setIsCollapsed(!isCollapsed)} />}
      
      <div className={`flex-1 flex flex-col min-h-screen transition-all duration-300 ${isCollapsed ? 'md:ml-16' : 'md:ml-1'}`}>
        <main className="flex-1 p-4 md:p-6">
          <div className="mx-auto w-full">
            {children}
          </div>
        </main>
        
        {!isAuthPage && (
          <footer className="bg-white border-t border-gray-200 py-4">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <p className="text-center text-sm text-gray-500">
                © {new Date().getFullYear()} Sistema de Pedidos. Todos los derechos reservados.
              </p>
            </div>
          </footer>
        )}
      </div>
    </div>
  );
};

export default MainLayout;
